/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {Modal} from 'react-bootstrap-v5'
import { allowShareProducts } from '../../store/StoreCRUD'
import { Toast } from '../../../modules/common/helper'
import { UserLoggedIn } from '../../../hooks/PermissionChecker'
import { IStoreModel } from '../../../models/StoreModel'
import * as auth from '../../../modules/auth/redux/AuthRedux'
import { useDispatch } from 'react-redux'

type Props = {
  show: boolean
  handleClose: () => void
  handleApprove: () => void
}

const ShareProductsRulesModal: React.FC<Props> = ({ show,  handleClose, handleApprove }) => {
    const dispatch = useDispatch();
    const user = UserLoggedIn();
    const [approved, setApproved] = useState<boolean>(true);
    
    // const handleApprove = async () => {
    //     if (!approved) {
    //         return;
    //     }
    //     try {
    //         const {data: data} = await allowShareProducts({allow_share_products: approved ? 1 : 0});
    //         let storeData: IStoreModel = data?.data?.store ?? null;
    //         if (storeData) {
    //             let newUser =  {...user, store: storeData};
    //             dispatch(auth.actions.setUser(newUser))
    //         }
    //         Toast.fire({
    //             icon: 'success',
    //             title: 'Cập nhật thành công'
    //         });
    //         handleClose();
    //     } catch (error) {
    //         console.log(error);
    //         Toast.fire({
    //             icon: 'error',
    //             title: 'Cập nhật cấu hình đầu kỳ thất bại'
    //         });
    //     }
    // };
    
    return (
        <Modal
            show={show}
            onHide={handleClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex p-4'>
                <Modal.Title
                    className='d-flex gap-3'
                >
                    <div className='rounded gap-3 p-3 d-flex align-items-center'>
                        <i className='fa fa-database text-primary' style={{fontSize: '3rem'}}></i>
                        <div>
                            <h3 className=' fw-bold'>Kích hoạt kho dữ liệu sản phẩm SENTO</h3>
                            <p className='mb-0 text-muted fs-6 fw-normal'>Quét nhanh hơn - Ít nhập liệu hơn - Dữ liệu ngày càng đầy đủ</p>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <div className='bg-light-primary rounded gap-3 p-3 mb-3 d-flex align-items-start'>
                    <span 
                        className='badge badge-primary badge-circle'
                        style={{
                            width: '3rem',
                            height: '3rem',
                            flex: '0 0 3rem'
                        }}
                    >
                        <i className='bi bi-search text-white' style={{fontSize: '1.5rem'}}></i>
                    </span>
                    <div>
                        <h4 className='text-primary fw-bold'>Sử dụng dữ liệu có sẵn</h4>
                        <p className='mb-0'>Quét mã Barcode để tìm và tạo sản phẩm nhanh chóng từ kho dữ liệu sản phẩm SENTO</p>
                    </div>
                </div>
                <div className='bg-light-warning rounded gap-3 p-3 mb-3 d-flex align-items-start'>
                    <span 
                        className='badge badge-warning badge-circle'
                        style={{
                            width: '3rem',
                            height: '3rem',
                            flex: '0 0 3rem'
                        }}
                    >
                        <i className='bi bi-cloud-arrow-up-fill text-white' style={{fontSize: '1.5rem'}}></i>
                    </span>
                    <div>
                        <h4 className='text-info fw-bold'>Cùng đóng góp dữ liệu sản phẩm</h4>
                        <p className='mb-0'>Sản phẩm có mã Barcode do bạn tạo mới (nếu chưa có trên SENTO) sẽ được bổ sung vào kho dữ liệu dùng chung.<br/>
                        Bạn cũng được sử dụng dữ liệu sản phẩm do cộng đồng người dùng SENTO đóng góp.</p>
                    </div>
                </div>
                <div className='bg-light-success rounded gap-3 p-3 mb-3 d-flex align-items-start'>
                     <span 
                        className='badge badge-success badge-circle'
                        style={{
                            width: '3rem',
                            height: '3rem',
                            flex: '0 0 3rem'
                        }}
                    >
                        <i className='bi bi-shield-lock-fill text-white' style={{fontSize: '1.5rem'}}></i>
                    </span>
                    <div>
                        <h4 className='text-info fw-bold'>Dữ liệu cửa hàng được bảo mật</h4>
                        <p className='mb-0'>Chỉ thông tin nhận diện sản phẩm như mã Barcode, tên sản phẩm, đơn vị tính và mô tả được dùng chung. Giá nhập, giá bán, tồn kho và dữ liệu kinh doanh của cửa hàng không được chia sẻ.</p>
                    </div>
                </div>
                <div className='bg-light-primary rounded p-3'>
                    <div className='form-check form-check-custom align-items-center'>
                        <input
                            type='checkbox'
                            className='form-check-input'
                            defaultChecked={approved}
                            onChange={(e) => {
                                setApproved(e.target.checked)
                            }}
                            id='allow_share_products'
                        />
                        <label className='form-check-label fw-bold' htmlFor={'allow_share_products'}>
                            Tôi đã đọc, hiểu và đồng ý kích hoạt Kho dữ liệu sản phẩm SENTO.
                        </label>
                    </div>
                </div>
                <div className='d-flex mb-4 justify-content-between pt-8'>
                    <button className="btn btn-bg-secondary" type="button" onClick={() => handleClose()}>Hủy</button>
                    <button disabled={!approved} onClick={handleApprove} className="btn btn-bg-primary text-white" type="button">Đồng ý & Kích hoạt</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export {ShareProductsRulesModal}
